import { render } from "./Proyeccion.vue?vue&type=template&id=d0ba13e2"
import script from "./Proyeccion.vue?vue&type=script&lang=js"
export * from "./Proyeccion.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GIT\\DevOps\\Planner\\FRONT_Planner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__